export default "__VITE_ASSET__DreuSuy6__"